/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { createIndexNode } from '../../factoriesNumber.js';
export var IndexNodeDependencies = {
  NodeDependencies,
  sizeDependencies,
  createIndexNode
};